<template>
  <i-modal :title="LANG.saveFilter">
    <form
      ref='form'>
      <input
        v-model='input'
        @keydown.enter.stop.prevent="() => save()"
        required
        ref='input'
        type='text'
        name='filter_name'
        class='form-control'
        :class="inputCSS"
        :minlength='minlength'
        :maxlength='maxlength'
        :placeholder='LANG.filterName' />
      <div class="helper form-hint">
        <div v-if="!isValidInput" class="error">{{LANG.filterInputNotValid}}</div>
        <div>{{remaining}}</div>
      </div>
    </form>

    <template #footer>
      <div>
        <i-button
          variant="secondary"
          @click.prevent="$emit('update:show', false)"
        >
          {{ LANG.cancel }}
        </i-button>
        <i-button
          variant="primary"
          @click.prevent="save"
        >
          {{ LANG.save }}
        </i-button>
      </div>
    </template>
  </i-modal>
</template>

<script>
import { mapState } from 'vuex';

export default {
  data() {
    return {
      input: '',
      testTrimmed: '',
      minlength: 3,
      maxlength: 25,
      regex: /^[\w]+$/,
    };
  },
  computed: {
    ...mapState(['LANG', 'browserMode']),
    isValidInput() {
      const { input, regex, testTrimmed } = this;

      const testValue = testTrimmed !== true
        ? input
        : input.trim();

      return input
        ? regex.test(testValue)
        : true;
    },
    remaining() {
      return `${this.input.length} / ${this.maxlength}`;
    },
    inputCSS() {
      return !this.isValidInput ? 'input-error' : '';
    },
  },
  methods: {
    save() {
      this.$store.dispatch(`${this.browserMode}/saveFilter`, { input: this.input });
      this.$emit('update:show', false);
      this.input = '';
    },
  },
};
</script>

<style scoped lang='scss'>
.helper {
  display: table;
  width: 100%;

  > div {
    display: table-cell;

    &:last-child {
      text-align: right;
    }
  }
}

.form-hint {
  margin: 5px 0 0 1px;
  color: #6b6b6b;
  font-size: 12px;
  font-weight: normal;

  .error,
  &.error {
    color: $red;
  }
}

::v-deep .input-error {
  border-color: $red !important;
}
</style>
